define([
    'lodash',
    'previewExtensionsCore',
    'santa-components',
    'componentsPreviewExtensions/bi/events'
], function (_, previewExtensionsCore, santaComponents, biEvents) {
    'use strict';

    const compType = 'wysiwyg.viewer.components.LanguageSelector';
    const previewExtensionsRegistrar = previewExtensionsCore.registrar;

    function reportBIClick() {
        if (this.state.isDropdownOpen) {
            return;
        }
        this.props.reportBI(biEvents.UOU_LANGUAGE_MENU_CLICKED, {
            page_id: this.props.pageId,
            main_language: this.props.originalLanguage.languageCode,
            current_language: this.props.currentLanguage.languageCode,
            languages: this.props.languages.map(function (language) {
                return language.languageCode;
            }).join()
        });
    }

    function showComponentNonInteractiveTooltip(tooltip, evt) {
        if (this.props.previewTooltipCallback) {
            const rect = _.pick(evt.target.getBoundingClientRect(), [
                'top',
                'left',
                'height',
                'width'
            ]);
            rect.top -= rect.height;
            this.props.previewTooltipCallback(rect, tooltip, {
                width: '300px',
                alignment: 'bottom'
            });
            this.props.reportBI(biEvents.DISABLED_LANGUAGE_MENU_TOOLTIP, {
                page_id: this.props.pageId
            });
        }
    }

    function allLanguagesDisabled({languages, originalLanguage}) {
        return !languages
            .filter(language => language.languageCode !== originalLanguage.languageCode)
            .some(language => language.status.toLowerCase() === 'active');
    }

    function isLanguageInactive(language) {
        return language.status && language.status.toLowerCase() === 'inactive';
    }

    function getHiddenComponentTooltipIfNeed({languages, originalLanguage, currentLanguage}) {
        if (isLanguageInactive(currentLanguage)) {
            return 'LangMenu_HiddenLanguage_Preview_Notification_Tooltip';
        }
        if (allLanguagesDisabled({languages, originalLanguage})) {
            return 'LangMenu_HiddenMenu_Preview_Notification_Tooltip';
        }
        return null;
    }

    const extension = {
        propTypes: {
            previewTooltipCallback:
                santaComponents.santaTypesDefinitions.RenderRealtimeConfig.previewTooltipCallback,
            languageCode:
                santaComponents.santaTypesDefinitions.RendererModel.languageCode,
            isExperimentOpen: santaComponents.santaTypesDefinitions.isExperimentOpen.isRequired,
            reportBI: santaComponents.santaTypesDefinitions.reportBI.isRequired
        },
        transformRefData: function transformRefData(refData) {
            if (!this.props.isExperimentOpen('se_multilingualDisableUouPreview') || !refData['']) {
                return;
            }
            refData[''].onClick = reportBIClick.bind(this);

            const hiddenComponentTooltip = getHiddenComponentTooltipIfNeed(this.props);
            if (!hiddenComponentTooltip) {
                return;
            }
            refData[''].onMouseEnter = showComponentNonInteractiveTooltip.bind(this, hiddenComponentTooltip);
        }
    };

    previewExtensionsRegistrar.registerCompExtension(compType, extension);

    return extension;
});
